import { theme, darkTheme } from './theme/themeVariables';

const config = {
  darkMode: false,
  topMenu: false,
  rtl: true,
  theme,
  darkTheme,
};

export default config;
